import React from 'react'


interface Props {
  className?: string
}


export const FacebookSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}>
      <path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07" />
    </svg>
  )
}

FacebookSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}

export const InstagramSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}>
      <path d="M16.98 0a6.9 6.9 0 015.08 1.98A6.94 6.94 0 0124 7.02v9.96c0 2.08-.68 3.87-1.98 5.13A7.14 7.14 0 0116.94 24H7.06a7.06 7.06 0 01-5.03-1.89A6.96 6.96 0 010 16.94V7.02C0 2.8 2.8 0 7.02 0h9.96zm.05 2.23H7.06c-1.45 0-2.7.43-3.53 1.25a4.82 4.82 0 00-1.3 3.54v9.92c0 1.5.43 2.7 1.3 3.58a5 5 0 003.53 1.25h9.88a5 5 0 003.53-1.25 4.73 4.73 0 001.4-3.54V7.02a5 5 0 00-1.3-3.49 4.82 4.82 0 00-3.54-1.3zM12 5.76c3.39 0 6.2 2.8 6.2 6.2a6.2 6.2 0 01-12.4 0 6.2 6.2 0 016.2-6.2zm0 2.22a3.99 3.99 0 00-3.97 3.97A3.99 3.99 0 0012 15.92a3.99 3.99 0 003.97-3.97A3.99 3.99 0 0012 7.98zm6.44-3.77a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8z" />
    </svg>
  )
}

InstagramSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}

export const TwitterSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}><path d="M24 4.37a9.6 9.6 0 01-2.83.8 5.04 5.04 0 002.17-2.8c-.95.58-2 1-3.13 1.22A4.86 4.86 0 0016.61 2a4.99 4.99 0 00-4.79 6.2A13.87 13.87 0 011.67 2.92 5.12 5.12 0 003.2 9.67a4.82 4.82 0 01-2.23-.64v.07c0 2.44 1.7 4.48 3.95 4.95a4.84 4.84 0 01-2.22.08c.63 2.01 2.45 3.47 4.6 3.51a9.72 9.72 0 01-7.3 2.1A13.68 13.68 0 007.55 22c9.06 0 14-7.7 14-14.37v-.65c.96-.71 1.79-1.6 2.45-2.61z" /></svg>
  )
}

TwitterSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}

export const YouTubeSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}><path d="M12.04 3.5c.59 0 7.54.02 9.34.5a3.02 3.02 0 012.12 2.15C24 8.05 24 12 24 12v.04c0 .43-.03 4.03-.5 5.8A3.02 3.02 0 0121.38 20c-1.76.48-8.45.5-9.3.51h-.17c-.85 0-7.54-.03-9.29-.5A3.02 3.02 0 01.5 17.84c-.42-1.61-.49-4.7-.5-5.6v-.5c.01-.9.08-3.99.5-5.6A3.02 3.02 0 012.62 4c1.8-.49 8.75-.51 9.34-.51zm-2.5 4.9v7.18L15.82 12 9.54 8.41z" /></svg>
  )
}

YouTubeSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}

export const LinkedInSvg: React.FC<Props> = (props) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" className={props.className}><path fillRule="evenodd" clipRule="evenodd" d="M0 1.838C0 1.35053.193646.883032.538338.53834S1.35053.000002 1.838.000002H20.16c.2416-.000394.4809.046863.7041.139067.2233.092204.4262.227543.5971.39827.171.170726.3065.373487.399.596671.0924.22319.1399.46242.1398.70399V20.16c.0003.2416-.0471.4809-.1394.7042-.0923.2233-.2278.4262-.3986.5971-.1708.1709-.3736.3065-.5969.3989-.2232.0924-.4625.1399-.7041.1398H1.838c-.24145 0-.48054-.0476-.7036-.14-.223065-.0924-.425729-.2279-.596416-.3987-.170687-.1708-.306052-.3735-.398361-.5966A1.83788 1.83788 0 010 20.161V1.838zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634 3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H8.708V8.388zm-5.5 10.403h3.208V8.25H3.208v10.541zM6.875 4.812a2.063032 2.063032 0 01-.14376.80332 2.062934 2.062934 0 01-.44401.68471 2.062922 2.062922 0 01-.67477.45898 2.063114 2.063114 0 01-.79996.16141c-.27474 0-.54671-.05488-.79995-.16141a2.062859 2.062859 0 01-.67478-.45898 2.062934 2.062934 0 01-.44401-.68471A2.063032 2.063032 0 012.75 4.812c.01187-.53914.23439-1.05221.61989-1.42931.3855-.37711.90333-.58827 1.44261-.58827s1.05711.21116 1.44262.58827c.3855.3771.60801.89017.61988 1.42931z" /></svg>
  )
}

LinkedInSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}

export const DiscordSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245 240" className={props.className}><path d="M104.4 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1.1-6.1-4.5-11.1-10.2-11.1zm36.5 0c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1s-4.5-11.1-10.2-11.1z" /><path d="M189.5 20h-134C44.2 20 35 29.2 35 40.6v135.2c0 11.4 9.2 20.6 20.5 20.6h113.4l-5.3-18.5 12.8 11.9 12.1 11.2 21.5 19V40.6c0-11.4-9.2-20.6-20.5-20.6zm-38.6 130.6s-3.6-4.3-6.6-8.1c13.1-3.7 18.1-11.9 18.1-11.9-4.1 2.7-8 4.6-11.5 5.9-5 2.1-9.8 3.5-14.5 4.3-9.6 1.8-18.4 1.3-25.9-.1-5.7-1.1-10.6-2.7-14.7-4.3-2.3-.9-4.8-2-7.3-3.4-.3-.2-.6-.3-.9-.5-.2-.1-.3-.2-.4-.3-1.8-1-2.8-1.7-2.8-1.7s4.8 8 17.5 11.8c-3 3.8-6.7 8.3-6.7 8.3-22.1-.7-30.5-15.2-30.5-15.2 0-32.2 14.4-58.3 14.4-58.3 14.4-10.8 28.1-10.5 28.1-10.5l1 1.2c-18 5.2-26.3 13.1-26.3 13.1s2.2-1.2 5.9-2.9c10.7-4.7 19.2-6 22.7-6.3.6-.1 1.1-.2 1.7-.2 6.1-.8 13-1 20.2-.2 9.5 1.1 19.7 3.9 30.1 9.6 0 0-7.9-7.5-24.9-12.7l1.4-1.6s13.7-.3 28.1 10.5c0 0 14.4 26.1 14.4 58.3 0 0-8.5 14.5-30.6 15.2z" /></svg>
  )
}

DiscordSvg.defaultProps = {
  className: 'w-8 h-8 fill-current text-black'
}